import React from 'react';
import AppLogo from '@/components/ui/AppLogo';

const stats = [
  { id: 'stat-companies', label: 'Active Companies', value: '247' },
  { id: 'stat-drivers', label: 'Drivers Online', value: '1,893' },
  { id: 'stat-bookings', label: 'Rides Today', value: '8,421' },
  { id: 'stat-countries', label: 'Countries', value: '34' },
];

export default function AuthLeftPanel() {
  return (
    <div
      className="hidden lg:flex flex-col justify-between w-[480px] xl:w-[560px] flex-shrink-0 p-10 relative overflow-hidden"
      style={{
        background: 'linear-gradient(145deg, #111118 0%, #0A0A0F 60%, #0D0A00 100%)',
        borderRight: '1px solid var(--border)',
      }}
    >
      {/* Background blobs */}
      <div
        className="absolute top-0 left-0 w-96 h-96 blob-primary pointer-events-none"
        style={{ transform: 'translate(-30%, -30%)' }}
      />
      <div
        className="absolute bottom-0 right-0 w-80 h-80 blob-accent pointer-events-none"
        style={{ transform: 'translate(20%, 20%)' }}
      />
      {/* Logo */}
      <div className="relative z-10">
        <div className="flex items-center gap-3 mb-12">
          <AppLogo size={40} />
          <div>
            <span className="font-bold text-xl tracking-tight" style={{ color: 'var(--primary)' }}>
              RideOS
            </span>
            <p className="text-xs" style={{ color: 'var(--muted-foreground)' }}>
              White-Label Mobility Platform
            </p>
          </div>
        </div>

        <h1 className="text-3xl font-bold leading-tight mb-4" style={{ color: 'var(--foreground)' }}>
          Launch your taxi or chauffeur business in{' '}
          <span style={{ color: 'var(--primary)' }}>minutes</span>
        </h1>
        <p className="text-sm leading-relaxed" style={{ color: 'var(--muted-foreground)' }}>
          RideOS gives taxi companies, airport transfer operators and limo services their own fully-branded booking platform — passengers app, driver app and dispatch portal — powered by a single shared backend.
        </p>
      </div>
      {/* Feature list */}
      <div className="relative z-10 space-y-3">
        {[
          { id: 'feat-1', text: 'Multi-tenant architecture — unlimited companies' },
          { id: 'feat-2', text: 'Full white-label — your brand, your domain' },
          { id: 'feat-3', text: 'Live driver tracking with Google Maps' },
          { id: 'feat-4', text: 'Stripe Connect payments & subscriptions' },
          { id: 'feat-5', text: 'Airport transfers, hourly hire, chauffeur bookings' },
        ]?.map((feat) => (
          <div key={feat?.id} className="flex items-center gap-3">
            <div
              className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0"
              style={{ background: 'rgba(245,158,11,0.15)' }}
            >
              <svg className="w-3 h-3" viewBox="0 0 12 12" fill="none">
                <path d="M2 6l3 3 5-5" stroke="#F59E0B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <span className="text-sm" style={{ color: 'var(--muted-foreground)' }}>
              {feat?.text}
            </span>
          </div>
        ))}
      </div>
      {/* Live stats */}
      <div className="relative z-10">
        <p className="text-xs font-medium mb-3 uppercase tracking-widest" style={{ color: 'var(--muted-foreground)' }}>
          Platform Live Stats
        </p>
        <div className="grid grid-cols-2 gap-3">
          {stats?.map((stat) => (
            <div
              key={stat?.id}
              className="rounded-xl p-4"
              style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border)' }}
            >
              <p className="font-mono text-xl font-bold tabular-nums" style={{ color: 'var(--primary)' }}>
                {stat?.value}
              </p>
              <p className="text-xs mt-0.5" style={{ color: 'var(--muted-foreground)' }}>
                {stat?.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}